import React, { useState, useEffect } from 'react'
import VideoBackground from 'components/VideoBackground'
const imageMap = {
    Sweaters: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2FJustin%20Sweaters.jpg?alt=media&token=c41806de-840b-4525-8006-13f0ff3fab27',

    Hats: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2Fhats%20justin.jpg?alt=media&token=816c1aeb-f494-466f-b406-cfcc25254890',

    Skincare: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2Fjoanna%20skincare.jpg?alt=media&token=86224647-8434-4f52-af02-638690c1d293',

    Shirts: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2FCJ%20Shirts.jpg?alt=media&token=eaf2b0d2-c74e-4c7e-aade-590dccda80ba',

    Masks: 'https://firebasestorage.googleapis.com/v0/b/dc1-ba765.appspot.com/o/IMG_1024.jpg?alt=media&token=52bcc285-bf91-4a46-b038-38fca17e9753',

    Backpack: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/images%2Fbookbag2.jpg?alt=media&token=f0456a7d-1f1a-45d7-9498-ba3b57cb9e7b',

    Sneakers: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2FMocha%20header.jpg?alt=media&token=996f2fe3-39c2-4416-ae52-54d6ee2a4f14',

    Shorts: 'https://firebasestorage.googleapis.com/v0/b/hullthread.appspot.com/o/PageImages%2Fathlete-runner-running-67LPMB6%20(1).jpg?alt=media&token=2c94b0b8-e05e-4b17-8e00-f3d8be0c6b1f'
}
const videomap = {
    Sweaters: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4',

    Hats: 'https://httest.s3.amazonaws.com/hats.mp4',

    Skincare: 'https://httest.s3.amazonaws.com/111_aXphX21fZXMyXzE4Ng_Trim+(1).mp4',

    Shirts: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4',

    Masks: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4',

    Sneakers: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4',

    Shorts: 'https://httest.s3.amazonaws.com/Comp+1_2.mp4'

}

function headerImage(props) {
    if (window.outerWidth > 500) {
        return (
            <div className={'stream_header'}>
                <VideoBackground src={videomap[props.Type]} height={'60vh'}></VideoBackground>
                <div className='header_wording'>{props.Type}</div>
            </div>
        )
    } else {
        return (
            <div className={'stream_header'}>
                <img className='header_img' src={imageMap[props.Type]}>
                </img>
                <div className='header_wording'>{props.Type}</div>
            </div>
        )
    }
}
export default headerImage

{/* <div className={'stream_header'}>
<img className='header_img' src={imageMap[props.Type]}>
</img>
<div className='header_wording'>{props.Type}</div>
</div> */}


// WEBPACK FOOTER //
// ./src/containers/Stream2/headerImage.jsx